/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 5/23/2023
 */
import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import Helpers from "../../utils/Helpers";
import api from "../../services/AuthApi";
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling";
import LoadingButton from "@mui/lab/LoadingButton";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteModal = ({
  open,
  onClose,
  title,
  setIsSuccess,
  setSuccessMessages,
  setIsPendingChange,
  setIserror,
  setErrorMessages,
  setIserrorShow,
  setIsUnauhtError,
}) => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const handleClear = () => {
    setTimeout(() => {
      setIsSuccess(false);
      setSuccessMessages([""]);
      setIserror(false);
      setErrorMessages([]);
      onClose();
      setIsPendingChange(true);
    }, 5000);
  };

  const handleDelete = () => {
    setIsBtnLoading(true);
    const payload = {
      data: {
        deletedRoles: [
          {
            role: title,
          },
        ],
      },
    };

    api
      .delete("/role/permissions", payload)
      .then((res) => {
        setIsBtnLoading(false);
        onClose();
        setIsSuccess(true);
        setSuccessMessages([res.data?.description]);
        setErrorMessages([]);
        setIserror(false);
        handleClear();
      })
      .catch((error) => {
        setIsBtnLoading(false);
        onClose();
        setIsSuccess(false);
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        );
        handleClear();
      });
  };

  return (
    <div>
      <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
        <DialogTitle textAlign="center">
          Are you sure you want to delete role{" "}
          {Helpers.underscoreRoleFormat(title)} ?
        </DialogTitle>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose} variant="outlined" color="error">
            Cancel
          </Button>

          <LoadingButton
            loading={isBtnLoading}
            onClick={handleDelete}
            color="error"
            variant="contained"
            loadingPosition="start"
            startIcon={<DeleteIcon />}>
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteModal;
